"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpDownRatio = void 0;
class UpDownRatio {
    constructor(obj) {
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.UpDownRatio = UpDownRatio;
//# sourceMappingURL=UpDownRatio.js.map